export default __webpack_public_path__ + "static/media/IntegrationInstagram.4bd1d061.jpg";